import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-unauthorised',
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `
    <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div class="max-w-md w-full text-center">
        <div class="mb-6">
          <div class="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i class="fas fa-lock text-red-500 text-3xl"></i>
          </div>
          <h1 class="text-3xl font-bold text-gray-800 mb-2">Access Denied</h1>
          <p class="text-gray-500 mb-6">
            You don't have permission to view this page.<br>
            Please contact your administrator if you believe this is an error.
          </p>
        </div>
        <a
          routerLink="/"
          class="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-lg hover:from-green-700 hover:to-green-600 transition-all duration-200 shadow-sm font-medium">
          <i class="fas fa-home mr-2"></i> Go Home
        </a>
      </div>
    </div>
  `
})
export class UnauthorisedComponent { }
